import useHandleActiveSpatialObject from './streamWS_hooks/useHandleActiveSpatialObject';
import useHandleAlertsBackfill from './streamWS_hooks/useHandleAlertsBackfill';
import useHandleAliLookback from './streamWS_hooks/useHandleAliLookback';
import useHandleCallEndedEvents from './streamWS_hooks/useHandleCallEndedEvents';
import useHandleCollaboratorCallEnded from './streamWS_hooks/useHandleCollaboratorCallEnded';
import useHandleCollaboratorMessage from './streamWS_hooks/useHandleCollaboratorMessage';
import useHandleConversationMessage from './streamWS_hooks/useHandleConversationMessage';
import useHandleDigitalDispatchMessages from './streamWS_hooks/useHandleDigitalDispatchMessages';
import useHandleGmrTransportMessages from './streamWS_hooks/useHandleGmrTransportMessages';
import useHandleMessageCategory from './streamWS_hooks/useHandleMessageCategory';
import useHandleTranscriptionSummaries from './streamWS_hooks/useHandleTranscriptionSummaries';
import useSpatialLayerIntersect from './streamWS_hooks/useSpatialLayerIntersect';

/**
 * Empty component that contains hooks usage for StreamWS callbacks
 */
const StreamWSCallbacks = () => {
  useHandleActiveSpatialObject();
  useSpatialLayerIntersect();
  useHandleMessageCategory();
  useHandleTranscriptionSummaries();
  useHandleCallEndedEvents();
  useHandleCollaboratorCallEnded();
  useHandleConversationMessage();
  useHandleCollaboratorMessage();
  useHandleGmrTransportMessages();
  useHandleDigitalDispatchMessages();
  useHandleAliLookback();
  useHandleAlertsBackfill();

  return <></>;
};

export default StreamWSCallbacks;
